'use strict';

customerZone.service('CustomerService', ['UnleashedClient', '$q', 'Storage', 'utils', function(api, $q, Storage, utils){

    var self = this;

    /**
     * Retrieve a customer
     * @param id Identifier of the account.  Leave empty to retrieve the account of the current user.
     * @returns A promise to the requested account.  If no account found, the promise will resolve to null.
     */
    self.getCustomer = function(){
        return api.getCustomer();
    };

    /**
     * Create a new customer with the given data
     * @param data account data for the new customer
     * @param recaptchaResponse a response for a valid recaptcha
     * @param subscriptionData the msisdn for the data to link, and a verification code (see #requestVerificationCode)
     * @return a promise to the id of the new customer
     */
    self.createCustomer = function(data, recaptchaResponse, subscriptionData){
        return api.createCustomer(data, recaptchaResponse, subscriptionData);
    };

    /**
     * This starts the creation for account for a pre-existing customer.  As a result it will return a promise for
     * a container of data that can be adjusted and filled out (at least the password field must be complete).
     *
     * At the end, invoke the complete function on the container to complete the creation.
     *
     * @param msisdn a JIM phone number already in active use to create an account for
     * @param verificationCode verificationCode for that number (see #requestVerificationCode)
     */
    self.createAccount = function(msisdn, verificationCode){
        if (msisdn.indexOf('@')>=0) throw new Error('New accounts can only be created for phone numbers');
        var temporaryPassword = utils.randomString(43);
        var loginToken;
        return api.passwordResetPerform(msisdn, verificationCode, temporaryPassword)
            .then(function() {
                return api.getToken(msisdn, temporaryPassword);
            })
            .then(function(response){
                loginToken = response.token;
                return api.authenticatedWith(loginToken).getCustomer();
            })
            .then(function(profile){

                return {
                    data: profile,
                    password: '',
                    complete: function(){
                        var newPassword = this.password;
                        return api.authenticatedWith(loginToken).updateCustomer(this.data)
                            .then(function(){
                                return api.authenticatedWith(loginToken).changePassword(temporaryPassword, newPassword);
                            }).then(function(){
                                // We set this here so that, if the other promise fails, we can
                                // redo the call without issues.
                                temporaryPassword = newPassword;
                            });
                    }
                };
            });
    };

    self.updateCustomer = function(data){
        return api.updateCustomer(data);
    };

    var PWD_RESET_TARGET_STORAGE_KEY = 'pwd_reset_target';

    /**
     * Request a password verification code
     * @param credentials email or msisdn for the password reset
     * @param recaptchaResponse a valid recaptcha response (required for the call)
     * @param targetUrl optional URL to return to after a mail-based reset.
     * @return promise that resolves after the token send request is done
     */
    self.requestVerificationCode = function(credentials, recaptchaResponse, targetUrl){
        return api.passwordResetRequest(credentials, recaptchaResponse)
            .then(function(result){
                Storage.setItem(PWD_RESET_TARGET_STORAGE_KEY, targetUrl || '');
                return result;
            });
    };

    /**
     * Reset the users password
     * @param credentials email or msisdn to change the password for
     * @param resetCode reset code as texted or mailed (see #requestVerificationCode)
     * @param newPassword the new password for the user
     * @return a promise that will resolve to the url to navigate to after reset, or to undefined if no navigation was
     *         requested.  It will reject in case of an error.
     */
    self.resetPassword = function(credentials, resetCode, newPassword) {
        return api.passwordResetPerform(credentials, resetCode, newPassword)
            .then(function(){
                var target = Storage.getItem(PWD_RESET_TARGET_STORAGE_KEY);
                Storage.removeItem(PWD_RESET_TARGET_STORAGE_KEY);
                if (target && target.length)
                    return target;
            });
    };

}]);
